import React from 'react';
import { Box, Image, EmptyState } from '@cubeyou-team/hx-react-components';
import { StyledResultsEmptyStateContainer } from '../../TaxonomyExplorer.styles';

const ResultsEmptyStateContainer = ({
  title,
  subtitle,
  icon,
  image,
  button,
}: {
  title?: string;
  subtitle?: string;
  icon?: string;
  image?: string;
  button?: any;
}) => {
  return (
    <StyledResultsEmptyStateContainer>
      {image && (
        <Box style={{ maxWidth: '500px' }}>
          <Image
            alt="audience"
            aspectratio="unset"
            src={image}
            title="audience"
          />
        </Box>
      )}
      <EmptyState
        button={button}
        icon={icon}
        mainText={title}
        smallText={subtitle}
        size="small"
      />
    </StyledResultsEmptyStateContainer>
  );
};
export default ResultsEmptyStateContainer;
